import { Pipe, PipeTransform, Injectable, SecurityContext } from '@angular/core';
import { NumberFormatService } from '@converter';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Injectable()
@Pipe({
    name: 'formatNumericValue',
    standalone: false
})
export class FormatNumericValuePipe implements PipeTransform {
    constructor(private formatService: NumberFormatService, private domSanitizer: DomSanitizer) { }

    private replacer: RegExp = /\{\{value\}\}/g;

    public async transform(formatString: string, input: number | string, representation: number, trustHtml: boolean = true): Promise<SafeHtml> {
        const sanitized = this.domSanitizer.sanitize(SecurityContext.HTML, formatString);
        if ((typeof input !== 'number' && typeof input !== 'string') || (representation !== 1 && representation !== 2)) {
            return trustHtml
                ? this.domSanitizer.bypassSecurityTrustHtml(sanitized)
                : sanitized;
        }
        const content = sanitized.replace(this.replacer,
            '<span title="' +
            this.domSanitizer.sanitize(SecurityContext.HTML, await this.formatService.format(input, representation === 2, false)) +
            '">' +
            this.domSanitizer.sanitize(SecurityContext.HTML, await this.formatService.format(input, representation === 2, true)) +
            '</span>');
        return trustHtml
            ? this.domSanitizer.bypassSecurityTrustHtml(content)
            : content;
    }
}
